(() => {
  if (customElements.get('kleone-testimonials')) return;
  class KleoneTestimonials extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.kt-track');
      this.cards = [...this.querySelectorAll('[data-kt-card]')];
      this.dots = [...this.querySelectorAll('[data-kt-dot]')];
      if (!this.track || !this.cards.length) return;
      const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
      const step = () => this.cards.length > 1 ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : this.track.clientWidth;
      const go = (index) => this.track.scrollTo({ left: index * step(), behavior: reduced() ? 'instant' : 'smooth' });
      const advance = (direction) => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const x = this.track.scrollLeft;
        if (direction > 0 && x >= max - 2) go(0);
        else if (direction < 0 && x <= 2) this.track.scrollTo({ left: max, behavior: reduced() ? 'instant' : 'smooth' });
        else go(Math.round(x / step()) + direction);
      };
      this.querySelector('[data-kt-prev]')?.addEventListener('click', () => advance(-1), options);
      this.querySelector('[data-kt-next]')?.addEventListener('click', () => advance(1), options);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), options));
      this.track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault(); advance(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.track.addEventListener('scroll', () => {
        const index = Math.round(this.track.scrollLeft / step());
        this.dots.forEach((dot, i) => { if (index === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.cards.indexOf(event.target.closest('[data-kt-card]'));
        if (index >= 0) go(index);
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('kleone-testimonials', KleoneTestimonials);
})();
